import axios from 'axios';
import { setCsrfToken, getCsrfToken } from './csrfTokenManager';

const API_URL = process.env.REACT_APP_API_URL;
// const API_URL = 'http://localhost:5000/api';


const fetchNewCsrfToken = async () => {
  const response = await axios.get(`${API_URL}/csrf-token`, { withCredentials: true });
  const newToken = response.data.csrfToken;
  setCsrfToken(newToken);
  return newToken;
};

const apiWrapper = async (method, endpoint, data = null) => {
  let retries = 0;
  const maxRetries = 3;

  while (retries < maxRetries) {
    try {
      let csrfToken = getCsrfToken();
      if (!csrfToken) {
        csrfToken = await fetchNewCsrfToken();
      }
      const response = await axios({
        method,
        url: `${API_URL}${endpoint}`,
        data: { ...data, _csrf: csrfToken },
        withCredentials: true,
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        console.log('CSRF token error detected. Fetching new token...');
        await fetchNewCsrfToken();
        retries++;
      } else if (error.message === 'Network Error') {
        console.log('Network error detected. Retrying...');
        await new Promise(resolve => setTimeout(resolve, 2000));
        retries++;
      } else {
        throw error;
      }
    }
  }

  throw new Error('Max retries reached. Unable to complete the request.');
};

export default apiWrapper;
